<template>
    <div>
        <div class="breadcrumbs overlay">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-8 offset-lg-2 col-md-12 col-12">
                        <div class="breadcrumbs-content">
                            <h1 class="page-title">Startup Studio</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="about-details detail-section">
            <div class="container">
                <div class="row">

                    <div class="col-12">
                        <div class="details-content">
                            <div class="text">
                                <div class="detail-section mt-4 wow fadeInUp" data-wow-delay=".2s">
                                    <p>
                                        The StartUp Studio is a Brand that Has only one focus which is to Spin out
                                        Profitable Companies or Companies that are investible from ideas, research works
                                        or partnered businesses.
                                        The StartUp Studio is not involved in non-profits, it however enshrines impacts.
                                    </p>

                                    <p>
                                        The StartUp Studio is a Revenue Generation and innovation-centered arm,
                                        leveraging shared resources, to build solutions which are solving genuine
                                        problems and impact the world while generating Value for all share or Stake
                                        holders.
                                    </p>
                                </div>

                                <div class="detail-section mt-4 wow fadeInUp" data-wow-delay=".2s">
                                    <p>
                                        The StartUp Studio has
                                    </p>
                                    <ul class="list">
                                        <li>
                                            Our Ideas Generated internally, or external ideas we are own between 50 and
                                            80% co-ownership with founders before dilution.
                                        </li>
                                        <li>
                                            Our Internal Project Management Infrastructure
                                        </li>
                                        <li>
                                            Our Internal Industries Departments to work on industry-specific Ideas
                                        </li>
                                        <li>
                                            An internal Business Research and Development Team
                                        </li>
                                        <li>
                                            it’s internal Product Development and management Team
                                        </li>
                                        <li>
                                            Its pool of Founders and Teams being Built (in collaboration with Talents
                                            development and incubation arm) or those Hired to take over portfolio brands
                                            to build
                                        </li>
                                        <li>
                                            Picks up ideas or product from R&D arm which is ripe for commercialization
                                            and is mostly ours in ownership
                                        </li>
                                        <li>
                                            A structure to share a pool of resources with Central Teams such as:
                                            <ul class="list">
                                                <li>
                                                    Tech Team
                                                </li>
                                                <li>
                                                    Talents Development Team
                                                </li>
                                                <li>
                                                    Data Team
                                                </li>
                                                <li>
                                                    Pool of External Advisors and thought Leaders
                                                </li>
                                                <li>
                                                    Finance
                                                </li>
                                                <li>
                                                    HR
                                                </li>
                                                <li>
                                                    Legal
                                                </li>
                                                <li>
                                                    Media, Marketing and Comms Teams
                                                </li>
                                                <li>
                                                    Business Development Team
                                                </li>
                                                <li>
                                                    Partnerships Team
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <p>
                                        All Products and brands go through Development Cycle, leveraging iterative and
                                        agile processes.
                                    </p>
                                </div>

                                <div class="detail-section mt-4 wow fadeInUp" data-wow-delay=".2s">
                                    <p>
                                        The Tribinnov StartUp Studio has the Cycle from Ideation to MVP, and 1st Market
                                        Entry within 60 days.
                                        The robust Thought leaders community serves as a large pool of experienced
                                        entrepreneurs with whom we brainstorm problems to solve.
                                    </p>
                                    <p>
                                        This helps us build in public, but within confines of safety, aside other great
                                        advantages.
                                    </p>
                                    <p>
                                        Do you have an idea you want us to own or build with you? or you’ve got some
                                        patent, research work to commercialize?
                                    </p>
                                    <div class="button my-5" style="text-align: center;">
                                        <a href="https://app.tribinnovafrica.com/register?type=innovator"
                                            target="_blank" class="btn">Submit An Idea <i
                                                class="lni lni-arrow-right"></i></a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StartupStudio',
        metaInfo: {
            title: "Tribinnov Africa - Startup Studio",
            meta: [
                { name: "keywords", content: "investment, finance, tribinnov, tribinnov africa, tribe of innovation, tribe, africa, nigeria, funding, crowdfunding, fundraiser" }
            ]
        }
    }
</script>